import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FunnelReport } from '../services/responses/dashboard.response';
import { Panel, PanelStat, PanelState, percent, useDashboardColors } from './panel';

interface Props {
    data?: FunnelReport;
}

/// Onde estão hoje os leads que entraram no período; mesma coorte do "Por que perdeu" ao lado.
export const OutcomeDonut = ({ data }: Props) => {
    const { t } = useTranslation();
    const cc = useDashboardColors();

    const slices = data
        ? [
            { key: 'open', label: t('painel.emAndamento'), value: data.outcomes.open, color: cc.accent },
            { key: 'won', label: t('painel.ganhos'), value: data.outcomes.won, color: cc.eventSuccess },
            { key: 'lost', label: t('painel.perdidos'), value: data.outcomes.lost, color: cc.eventDanger },
        ]
        : [];
    const total = slices.reduce((sum, slice) => sum + slice.value, 0);
    const share = (value: number) => percent(Math.round((value / total) * 1000) / 10);

    return (
        <Panel
            title={t('painel.situacaoTitulo')}
            subtitle={t('painel.situacaoAjuda')}
            stats={total > 0 && <PanelStat label={t('painel.leadsNovos')} value={total} />}
        >
            {!data || total === 0 ? (
                <PanelState loading={!data} empty={t('crmDashboard.semDados')} />
            ) : (
                <Box sx={{ display: 'grid', gap: 1.5 }}>
                    <Box sx={{ height: 180 }}>
                        <Doughnut
                            data={{
                                labels: slices.map((slice) => slice.label),
                                datasets: [{
                                    data: slices.map((slice) => slice.value),
                                    backgroundColor: slices.map((slice) => slice.color),
                                    borderColor: cc.cardBg,
                                    borderWidth: 2,
                                }],
                            }}
                            options={{
                                maintainAspectRatio: false,
                                cutout: '65%',
                                plugins: {
                                    legend: { display: false },
                                    tooltip: {
                                        callbacks: {
                                            label: (item) => ` ${item.label}: ${item.raw} (${share(Number(item.raw))})`,
                                        },
                                    },
                                },
                            }}
                        />
                    </Box>

                    {/* Legenda com número e percentual: a cor sozinha não diz quanto é. */}
                    {slices.map((slice) => (
                        <Box key={slice.key} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box aria-hidden sx={{ width: 10, height: 10, borderRadius: '3px', flexShrink: 0, background: slice.color }} />
                            <Typography sx={{ flex: 1, color: cc.textSecondary, fontSize: '0.78rem' }}>{slice.label}</Typography>
                            <Typography sx={{ color: cc.textPrimary, fontSize: '0.8rem', fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
                                {slice.value}
                                <Box component="span" sx={{ color: cc.textMuted, fontWeight: 500, fontSize: '0.72rem' }}>
                                    {' · '}{share(slice.value)}
                                </Box>
                            </Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </Panel>
    );
};
